import { Box } from '@chakra-ui/react';
import DisplayModeConfiguration from '@components/displayMode/DisplayModeConfiguration';
import { Toaster } from '@components/ui/toaster/toaster';
import { useAuth } from '@hooks/useAuth';
import { Navigate, Route, Routes, useLocation } from 'react-router';

import { RoutesEnum } from '@/types/routes.types';

import Cockpit from './cockpit/Cockpit';
import { CockpitPanelRouter, PANEL_ROUTES } from './cockpit/CockpitRoutes';
import DisplayGrid from './cockpit/DisplayGrid';
import HasBeenLoggedOutModal from './HasBeenLoggedOutModal';
import Login from './login/Login';
import PrivateOutlet from './login/PrivateOutlet';
import PrivateOutletOther from './login/PrivateOutletOther';

export default function App() {
  const { token } = useAuth();
  const { pathname } = useLocation();
  sessionStorage.setItem('route', pathname);

  return (
    <Box width="100vw" height="100vh" overflow="hidden" bgGradient="linear-gradient(180deg, #000000 0%, #041b2f 100%)">
      <Routes>
        <Route path={RoutesEnum.LOGIN} element={token ? <Navigate to={RoutesEnum.COCKPIT} replace /> : <Login />} />
        <Route element={<PrivateOutlet />}>
          <Route path={RoutesEnum.COCKPIT} element={<Cockpit />}>
            <Route path=":panel" element={<CockpitPanelRouter />} />
            <Route index element={<Navigate to={PANEL_ROUTES.NOTIFICATION} replace />} />
          </Route>
          <Route path={RoutesEnum.DISPLAY_MODE} element={<DisplayModeConfiguration />} />
        </Route>
        <Route element={<PrivateOutletOther />}>
          <Route path={`${RoutesEnum.SCREEN}/:code`} element={<DisplayGrid />} />
        </Route>
        <Route path="*" element={<Navigate to={RoutesEnum.COCKPIT} replace />} />
      </Routes>
      <HasBeenLoggedOutModal />
      <Toaster />
    </Box>
  );
}
